<nz-card [nzTitle]="cardTitle" [nzExtra]="cardExtra" class="chart-box mt-md">
  <ng-template #cardTitle>
    <lib-fl-tabs [tabs]="tabs" [ngModel]="activeTab" (ngModelChange)="onTabChange($event)"></lib-fl-tabs>
  </ng-template>
  <ng-template #cardExtra>
    @if (selectChart === 'column' && taskAnalysisSrv.taskPackDetails.length) {
      <div>
        <nz-select
          nzVariant="borderless"
          nzSize="small"
          style="width: 130px"
          nzPlaceHolder="对比目标"
          [(ngModel)]="compareTaskId"
          (ngModelChange)="getTaskQuestionsStatis($event)"
        >
          @for (detail of compareClassroom; track detail) {
            <nz-option [nzLabel]="detail.classroomName" [nzValue]="detail.taskId"></nz-option>
          }
        </nz-select>
        <nz-select
          nzVariant="borderless"
          nzSize="small"
          style="width: 130px"
          nzPlaceHolder="得分率筛选"
          [(ngModel)]="correctFilter"
          (ngModelChange)="correctChange($event)"
        >
          <nz-option [nzLabel]="'无'" [nzValue]="null"></nz-option>
          <nz-option [nzLabel]="'≤80'" [nzValue]="80"></nz-option>
          <nz-option [nzLabel]="'≤70'" [nzValue]="70"></nz-option>
          <nz-option [nzLabel]="'≤60'" [nzValue]="60"></nz-option>
          <nz-option [nzLabel]="'≤50'" [nzValue]="50"></nz-option>
        </nz-select>
      </div>
    }
  </ng-template>

  <div
    class="chart-container"
    id="chart-container"
    style="overflow-x: auto; width: 100%; padding-top: 30px"
    [hidden]="[TabsKeyEnum.Module, TabsKeyEnum.Feedback].includes(activeTab)"
  >
    <fl-task-analysis-column-div-chart
      [questionsStatis]="questionsStatis"
      [compareQuestionsStatis]="compareQuestionsStatis"
      [currentQuestionNo]="currentQuestionNo()"
      [correctFilter]="correctFilter"
      [isGroup]="columnOptions.isGroup"
      [studentCount]="$safeNavigationMigration(task?.studentCount)"
      (changeNo)="changeNo.emit($event)"
    ></fl-task-analysis-column-div-chart>
  </div>
  <div
    [hidden]="[TabsKeyEnum.Question, TabsKeyEnum.Feedback].includes(activeTab) || disabledModule"
    style="width: 100%"
  >
    <div #echartsBar style="width: 100%; height: 240px"></div>
  </div>
  @if (activeTab === TabsKeyEnum.Module && disabledModule) {
    <nz-empty nzNotFoundImage="simple"></nz-empty>
  }
  @if (activeTab === TabsKeyEnum.Feedback) {
    <fl-task-feedback [task]="task" (unreadChange)="feedbackNumChange($event)"></fl-task-feedback>
  }
</nz-card>
